<template>
  <a-tooltip v-if="isShowSync" placement="top">
    <template #title>
      <div>
        <span style="font-size: 15px">
          如果店铺的分类在支付宝后台有改动过，则需要点击同步类目按钮，会进行一次同步类目的操作
        </span>
        <div style="text-align: right">
          <a-button style="margin-left: 1em; margin-top: 0.5em" type="primary" :loading="loading" @click="syncCategory"
            >同步类目</a-button
          >
        </div>
      </div>
    </template>
    <a-select
      :value="category"
      :filter-option="filterSelect"
      show-search
      :allowClear="true"
      class="mall-category-select"
      placeholder="输入关键字搜索店铺里的类目"
      @change="changeCategory"
    >
      <a-select-option v-for="item in categoryList" :key="item.Ids" :value="item.Ids">
        {{ item.Names }}
      </a-select-option>
    </a-select>
  </a-tooltip>
  <a-select
    v-else
    :value="category"
    :filter-option="filterSelect"
    show-search
    :allowClear="true"
    class="mall-category-select"
    :placeholder="'输入关键字搜索店铺里的类目' + (placeholder || '')"
    @change="changeCategory"
  >
    <a-select-option v-for="item in categoryList" :key="item.Ids" :value="item.Ids">
      {{ item.Names }}
    </a-select-option>
  </a-select>
</template>
<script>
//import api from './api'
import store from "@/store";
export default {
  props: {
    placeholder: {
      type: String,
    },
    category: {
      type: String,
    },
    categoryList: {
      type: Array,
      default: () => [],
    },
    isShowSync: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    // 改变当前分类时触发
    changeCategory(category) {
      this.$emit("change", category);
    },
    // 搜索分类
    filterSelect(input, option) {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    // 同步类目
    async syncCategory() {
      this.loading = true;
      // const { list, success, msg } = await api.GetGoodsCategoryList(true)
      const { list, success, msg } = await store.dispatch("mall_group/getMallCategory");
      const str = "同步店铺类目";
      if (!success) this.$message.warn(`${str}失败，原因:【${msg}】`);
      else this.$message.success(`${str}成功`);
      this.loading = false;
      this.$emit("sync-category", list);
    },
  },
};
</script>
<style scoped lang="less">
.mall-category-select {
  width: 418px;
  font-size: 15px;
}
</style>
